<script setup lang="ts">
// Handle service worker messages for notification clicks
onMounted(() => {
  if ('serviceWorker' in navigator) {
    console.log('[app.vue] ✅ Service Worker disponível')

    // Verifica se já há um service worker registrado
    navigator.serviceWorker.ready.then((registration) => {
      console.log('[app.vue] 📋 Service Worker registrado:', registration)
    })
  } else {
    console.log('[app.vue] ❌ Service Worker não disponível')
  }
})
</script>

<template>
  <NuxtLayout />
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  /* filter: blur(5px); */
}
.layout-enter-active,
.layout-leave-active {
  transition: all 0.4s;
}
.layout-enter-from,
.layout-leave-to {
  opacity: 0;
  /* filter: blur(5px); */
}
</style>
